import { useState, useEffect, useRef } from 'react';
import { isEmpty } from './func';

const ReferenceNumber = ({
  className,
  placeholder,
  value,
  onChange,
  onValidate,
  showError,
  required,
  disabled,
  decimalPlaces = 4,
  min,
  max,
}) => {
  const [error, setError] = useState(null);
  const [displayValue, setDisplayValue] = useState(value);
  const isTypingRef = useRef(false);

  useEffect(() => {
    if (!isTypingRef.current) {
      setDisplayValue(value?.toString() || '');
    }
  }, [value]);

  // Validate function
  const validate = () => {
    if (isEmpty(displayValue)) {
      if (required) return 'Required.';
      return null;
    }
    const numericValue = parseFloat(displayValue);
    if (!isNaN(numericValue)) {
      if (min !== undefined && numericValue < min) return `Value ≥ ${min}.`;
      if (max !== undefined && numericValue > max) return `Value ≤ ${max}.`;
    }
    return null;
  };

  useEffect(() => {
    const msg = validate();
    setError(msg);
    if (onValidate) onValidate(msg == null);
  }, [displayValue]);

  const handleChange = (inputValue) => {
    isTypingRef.current = true;
    setDisplayValue(inputValue);

    // Remove thousand separators (commas) and validate
    const cleanedValue = inputValue.replace(/,/g, '');

    // Allow only numbers and decimals
    if (!/^\d*\.?\d*$/.test(cleanedValue)) return;

    if (!isNaN(cleanedValue) && cleanedValue !== '') {
      // Pass the cleaned value without commas
      onChange?.({ target: { value: cleanedValue } });
    } else if (cleanedValue === '') {
      onChange?.({ target: { value: '' } });
    }
  };

  const handleBlur = () => {
    isTypingRef.current = false;
  };

  return (
    <>
      <input
        type="text"
        inputMode="decimal"
        className={className}
        placeholder={placeholder}
        disabled={disabled}
        value={displayValue}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={handleBlur}
        onWheel={(e) => e.target.blur()}
      />
      {error && showError && <span className="invalid">{error}</span>}
    </>
  );
};

export default ReferenceNumber;
